<template>
  <v-app style="width: 100%" class="pa-3 pt-0">
    <div>
      <div style="display: flex">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" icon class="float-left mt-1" small v-on="on">
              <v-icon color="primary" style="font-size: 22px" @click="print">
                mdi-cloud-print-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("print") }}</span>
        </v-tooltip>
        <v-card-text class="py-0">
          <v-chip-group
            v-model="printSize"
            active-class="deep-purple--text text--accent-4"
            mandatory
          >
            <v-chip small value="29.7cm 21cm"> A4 </v-chip>
            <v-chip small value="21cm 14.8cm"> A5 </v-chip>
            <v-chip small value="14.8cm 10.5cm"> A6 </v-chip>
            <v-chip small value="10.5cm 7.4cm"> A7 </v-chip>
            <v-chip small value="5.2cm 7.4cm"> A7 </v-chip>
            <v-chip v-if="!width && !height" small @click="customSizeDialog = true">
              {{ $t("custom") }}
            </v-chip>
            <v-chip
              v-if="width && height"
              small
              close
              color="primary"
              outlined
              @click:close="clearCustom"
              @click="customSizeDialog = true"
            >
              {{ width + "cm" }} × {{ height + "cm" }}
            </v-chip>
          </v-chip-group>
        </v-card-text>
      </div>
    </div>
    <div id="print_dialog">
      <v-data-table
        v-if="headerPrint"
        ref="table"
        :headers="headerPrint"
        :items="items"
        :items-per-page="8000000000000"
        hide-default-footer
      >
        <template v-slot:item.firstname="{ item }">
          {{ item.firstname }} {{ item.lastname ? item.lastname : "" }}
          {{ item.code ? "(" + item.code + ")" : "" }}
        </template>
        <template v-slot:item.user="{ item }">
          {{ item.user.firstname }} ( {{ item.user.lastname }} )
        </template>
        <template v-slot:item.price="{ item }">
          {{ $numberFormat(parseFloat(item.price)) }}
        </template>
        <template v-slot:item.price.price="{ item }">
          {{ $numberFormat(item.price ? item.price.price : 0) }}
          {{ item.currency.symbol }}
        </template>
        <template v-slot:item.fee="{ item }">
          {{ $numberFormat(item.fee ? item.fee : 0) }}
          <v-chip small>
            {{ item.head.currency.name }}
          </v-chip>
        </template>
        <template v-slot:item.sumCurrency="{ item }">
          {{ $numberFormat(item.sumCurrency) }}
          <v-chip small>
            {{ item.head.currency.name }}
          </v-chip>
        </template>
        <template v-slot:item.sum_amount="{ item }">
          {{ $numberFormat(item.sum_amount ? item.sum_amount : 0) }}
        </template>
        <template v-slot:item.Commission="{ item }">
          {{ $numberFormat(item.Commission ? item.Commission : 0) }}
        </template>
        <template v-slot:item.sum_discount="{ item }">
          {{ $numberFormat(item.sum_discount ? item.sum_discount : 0) }}
        </template>
        <template v-slot:item.sum_tax="{ item }">
          {{ $numberFormat(item.sum_tax ? item.sum_tax : 0) }}
        </template>
        <template v-slot:item.count_remain="{ item }">
          {{
            +(item.count_in ? item.count_in : 0) - +(item.count_out ? item.count_out : 0)
          }}
        </template>
        <template v-slot:item.sum_cost="{ item }">
          {{ $numberFormat(parseFloat(item.sum_cost)) }}
        </template>
        <template v-slot:item.sum_price="{ item }">
          {{ $numberFormat(+item.price_in - +item.price_out) }}
        </template>
        <template v-slot:item.id="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:item.row="{ item }">
          {{ parseInt(items.indexOf(item)) + parseFloat(1) }}
        </template>
        <template v-slot:item.tags="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.relations="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(relation, index) in item.relations"
              :key="index"
              :color="relation.color"
              label
              outlined
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              {{ $t(relation.doc_type) }} {{ $t("number") }} : {{ relation.number }} -
              {{ $t("amount") }} : {{ relation.amount }}
            </v-chip>
          </div>
        </template>
        <template v-slot:item.tax="{ item }">
          {{ $numberFormat(parseFloat(item.tax)) }}
        </template>
        <template v-slot:item.amount="{ item }">
          {{ $numberFormat(parseFloat(item.amount)) }}
        </template>
        <template v-slot:item.price.sum_debtor="{ item }">
          {{ $numberFormat(item.price ? item.price.sum_debtor : 0) }}
        </template>
        <template v-slot:item.price.sum_creditor="{ item }">
          {{ $numberFormat(item.price ? item.price.sum_creditor : 0) }}
        </template>
        <template v-slot:item.debtor="{ item }">
          {{ $numberFormat(parseFloat(item.debtor)) }}
        </template>
        <template v-slot:item.creditor="{ item }">
          {{ $numberFormat(parseFloat(item.creditor)) }}
        </template>
        <template v-slot:item.discount="{ item }">
          {{ $numberFormat(parseFloat(item.discount)) }}
        </template>
        <template v-slot:item.remain="{ item }">
          {{ item.remain ? $numberFormat(item.remain.remain) : 0 }}
        </template>
        <template v-slot:item.state="{ item }">
          <v-chip
            v-show="item.remain && parseFloat(item.remain.remain) < 0"
            small
            color="blue"
            outlined
          >
            {{ $t("creditor") }}
          </v-chip>
          <v-chip
            v-show="item.remain && item.remain.remain > 0"
            small
            color="red"
            outlined
          >
            {{ $t("debtor") }}
          </v-chip>
          <v-chip
            v-show="item.remain && item.remain.remain == null"
            small
            color="green"
            outlined
          >
            {{ $t("clearing") }}
          </v-chip>
        </template>
        <template v-slot:item.plan="{ item }">
          <div class="pt-1">
            <v-chip
              v-if="item.plan"
              color="primary"
              label
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ item.plan.plan.name }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.sumAmount="{ item }">
          {{ $numberFormat(item.sum) }}
          <v-chip :color="item.sum > 0 ? 'pink' : 'green'" label small class="px-1 mb-1">
            <span class="px-1 white--text">
              {{ item.sum > 0 ? $t("debtor") : $t("creditor") }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.fin4="{ item }">
          {{ item.fin4 ? item.fin4.name : "" }}
        </template>
        <template v-slot:item.currency="{ item }">
          {{ item.currency ? item.currency.symbol : "" }}
        </template>
        <template v-slot:item.reviewContent="{ item }">
          {{ item.groupName }}
          {{ reviewLevelProp != "group" ? " / " + item.totalName : "" }}
          {{
            reviewLevelProp != "group" && reviewLevelProp != "total"
              ? " / " + item.givenName
              : ""
          }}
          {{
            reviewLevelProp != "group" &&
            reviewLevelProp != "total" &&
            reviewLevelProp != "given" &&
            reviewLevelProp == "detail" &&
            item.fin4
              ? " / " + item.fin4.name
              : ""
          }}
          {{ reviewLevelProp == "turnover" ? " / " + item.content : "" }}
        </template>
        <template v-slot:item.content="{ item }">
          <div>
            {{ item.content }}
          </div>
          <div
            v-if="
              item.reference &&
              item.reference.article &&
              dataProp &&
              dataProp.showInvoiceDetail
            "
            style="margin-bottom: 6px"
          >
            <v-simple-table dense style="background-color: #e3e3e3">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">
                      {{ $t("product-name") }}
                    </th>
                    <th class="text-center">
                      {{ $t("count") }}
                    </th>
                    <th class="text-center">
                      {{ $t("fee") }}
                    </th>
                    <th class="text-center">
                      {{ $t("sum") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(article, i) in item.reference.article" :key="i">
                    <td class="text-center">
                      {{ article.product.name }}
                    </td>
                    <td class="text-center">
                      {{ article.count }}
                    </td>
                    <td class="text-center">
                      {{ $numberFormat(article.fee) }}
                    </td>
                    <td class="text-center">
                      {{
                        $numberFormat(
                          (
                            +(article.count * article.fee) -
                            +article.discount +
                            +article.tax
                          ).toFixed($store.state.currency.decimal)
                        )
                      }}
                    </td>
                  </tr>
                  <tr v-if="item.reference.discount && item.reference.discount > 0">
                    <td colspan="2" class="text-center">
                      {{ $t("discount") }}
                    </td>
                    <td class="text-center" />
                    <td class="text-center">
                      {{ $numberFormat(item.reference.discount) }}-
                    </td>
                  </tr>
                  <tr v-if="item.reference.tax && item.reference.tax > 0">
                    <td colspan="2" class="text-center">
                      {{ $t("tax") }}
                    </td>
                    <td class="text-center" />
                    <td class="text-center">
                      {{ $numberFormat(item.reference.tax) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </template>
        <template v-slot:item.stock="{ item }">
          {{ item.stock ? item.stock.count : "" }}
        </template>
        <template v-slot:item.contentTurnover="{ item }">
          <div v-if="item.head.ref_type !== 'transfer'">
            {{ item.content }}
          </div>
          <div v-if="item.head.ref_type === 'transfer'">
            {{
              !showSummaryTransferContentProp
                ? item.content
                : $t("transferDocumentFrom") + " " + (item.fin4 ? item.fin4.name : "")
            }}
          </div>
          <div
            v-if="
              item.reference &&
              item.reference.article &&
              dataProp &&
              dataProp.showInvoiceDetail
            "
            style="margin-bottom: 6px"
          >
            <v-simple-table
              dense
              class="v-data-table__wrapper__height_off"
              style="background-color: #e3e3e3"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">
                      {{ $t("product-name") }}
                    </th>
                    <th class="text-center">
                      {{ $t("count") }}
                    </th>
                    <th class="text-center">
                      {{ $t("fee") }}
                    </th>
                    <th class="text-center">
                      {{ $t("sum") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(article, i) in item.reference.article" :key="i">
                    <td class="text-center">
                      {{ article.product.name }}
                    </td>
                    <td class="text-center">
                      {{ article.count }}
                    </td>
                    <td class="text-center">
                      {{ $numberFormat(article.fee) }}
                    </td>
                    <td class="text-center">
                      {{
                        $numberFormat(
                          (
                            +(article.count * article.fee) -
                            +article.discount +
                            +article.tax
                          ).toFixed($store.state.currency.decimal)
                        )
                      }}
                    </td>
                  </tr>
                  <tr v-if="item.reference.discount && item.reference.discount > 0">
                    <td colspan="2" class="text-center">
                      {{ $t("discount") }}
                    </td>
                    <td class="text-center" />
                    <td class="text-center">
                      {{ $numberFormat(item.reference.discount) }}-
                    </td>
                  </tr>
                  <tr v-if="item.reference.tax && item.reference.tax > 0">
                    <td colspan="2" class="text-center">
                      {{ $t("tax") }}
                    </td>
                    <td class="text-center" />
                    <td class="text-center">
                      {{ $numberFormat(item.reference.tax) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <div v-if="item.reference && item.reference.content" class="mb-1">
            - {{ item.reference.content }}
          </div>
        </template>
        <template v-slot:item.price.price="{ item }">
          {{ $numberFormat(item.price ? item.price.price : 0) }}
          {{ item.currency.symbol }}
        </template>
        <template v-slot:item.price.NetPrice="{ item }">
          {{ $numberFormat(item.price ? item.price.NetPrice : 0) }}
          {{ item.currency.symbol }}
        </template>
        <template v-slot:item.payed.amount="{ item }">
          {{ $numberFormat(item.payed ? item.payed.amount : 0) }}
          {{ item.currency.symbol }}
          <v-chip
            v-if="item.payed"
            class="mx-0"
            :color="
              parseFloat(item.price.price) - parseFloat(item.payed.amount) > 0
                ? 'red'
                : 'green'
            "
            small
            outlined
          >
            {{
              parseFloat(item.price.price) - parseFloat(item.payed.amount) > 0
                ? $t("remainPrice") +
                  " " +
                  $numberFormat(
                    parseFloat(item.price.price) - parseFloat(item.payed.amount)
                  )
                : $t("payed")
            }}
          </v-chip>
        </template>
        <template v-slot:item.payed.paymentsAmount="{ item }">
          {{ $numberFormat(item.payed ? item.payed.paymentsAmount : 0) }}
          {{ item.currency.symbol }}
        </template>
        <template v-slot:item.payed.checksAmount="{ item }">
          {{ $numberFormat(item.payed ? item.payed.checksAmount : 0) }}
          {{ item.currency.symbol }}
        </template>
        <template v-slot:item.tax="{ item }">
          {{ $numberFormat(item.tax ? item.tax : 0) }}
        </template>
        <template v-slot:item.kind="{ item }">
          {{ item.type == "own" ? $t("normal") : $t(item.kind) }}
        </template>
        <template v-slot:item.status.status="{ item }">
          <v-chip
            v-if="item.status && item.status.status"
            :color="item.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
            @click="openCheckStatusDialog(item)"
          >
            <span class="px-2 white--text">
              {{ $t(item.status.status) }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.payed_account_id && item.type == 'customer'"
            color="primary"
            label
            small
            style="cursor: pointer"
            class="px-1 ma-1"
          >
            <span class="px-2 white--text">
              {{ $t("to") }} {{ $t(item.payed_account.name) }} - {{ $t("date") }}:{{
                item.payed_date
              }}
            </span>
          </v-chip>
          <v-chip
            v-if="type == 'payCheck' && item.type == 'customer'"
            color="teal"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ $t("recieveCheck") }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.initial_period"
            color="primary"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ $t("initialPeriod") }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.status && item.status.bank"
            color="green"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ item.status.bank.name }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.status && item.status.bank"
            color="orange"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ $t("lastChangeStatus") }} : {{ item.status.time }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.discount="{ item }">
          {{ $numberFormat(item.discount ? item.discount : 0) }}
        </template>
        <template v-slot:item.product.tags="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(tag, index) in item.product.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.sumDebtor="{ item }">
          {{ $numberFormat(item.sumDebtor) }}
        </template>
        <template v-slot:item.sumCreditor="{ item }">
          {{ $numberFormat(item.sumCreditor) }}
        </template>
        <template v-slot:item.debtorRemain="{ item }">
          {{
            $numberFormat(
              item.sumDebtor - item.sumCreditor > 0
                ? item.sumDebtor - item.sumCreditor
                : 0
            )
          }}
        </template>
        <template v-slot:item.creditorRemain="{ item }">
          {{
            $numberFormat(
              item.sumCreditor - item.sumDebtor > 0
                ? item.sumCreditor - item.sumDebtor
                : 0
            )
          }}
        </template>
        <template v-slot:item.head.tags="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(tag, index) in item.head.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.sumCurrency="{ item }">
          {{ $numberFormat(item.sumCurrency) }}
          <v-chip small>
            {{ item.head.currency.name }}
          </v-chip>
        </template>
        <template v-slot:item.sum_amount="{ item }">
          {{ $numberFormat(item.sum_amount ? item.sum_amount : 0) }}
        </template>
        <template v-slot:item.Commission="{ item }">
          {{ $numberFormat(item.Commission ? item.Commission : 0) }}
        </template>
        <template v-slot:item.sum_discount="{ item }">
          {{ $numberFormat(item.sum_discount ? item.sum_discount : 0) }}
        </template>
        <template v-slot:item.sum_tax="{ item }">
          {{ $numberFormat(item.sum_tax ? item.sum_tax : 0) }}
        </template>
        <template v-slot:item.sum_cost="{ item }">
          {{ $numberFormat(item.sum_cost ? item.sum_cost : 0) }}
        </template>
        <template v-slot:item.product_profit="{ item }">
          {{ $numberFormat(item.product_profit ? item.product_profit : 0) }}
        </template>
        <template v-slot:item.sum_other_cost="{ item }">
          {{ $numberFormat(item.sum_other_cost ? item.sum_other_cost : 0) }}
        </template>
        <template v-slot:item.count_product_invoice="{ item }">
          {{ $numberFormat(item.count_product_invoice ? item.count_product_invoice : 0) }}
        </template>
        <template v-slot:item.count_product_return_invoice="{ item }">
          {{
            $numberFormat(
              item.count_product_return_invoice ? item.count_product_return_invoice : 0
            )
          }}
        </template>
        <template v-slot:item.count_invoice="{ item }">
          {{ $numberFormat(item.count_invoice ? item.count_invoice : 0) }}
        </template>
        <template v-slot:item.count_return_invoice="{ item }">
          {{ $numberFormat(item.count_return_invoice ? item.count_return_invoice : 0) }}
        </template>
        <template v-slot:item.amount_invoice="{ item }">
          {{ $numberFormat(item.amount_invoice ? item.amount_invoice : 0) }}
        </template>
        <template v-slot:item.amount_return_invoice="{ item }">
          {{ $numberFormat(item.amount_return_invoice ? item.amount_return_invoice : 0) }}
        </template>
        <template v-slot:item.remainCount="{ item }">
          {{
            $numberFormat(
              +item.count_product_invoice - +item.count_product_return_invoice
            )
          }}
        </template>
        <template v-slot:item.remainAmount="{ item }">
          {{ $numberFormat(+item.amount_invoice - +item.amount_return_invoice) }}
        </template>
        <template v-slot:body.append>
          <tr
            v-if="productItemsInvoice"
            :class="{ 'v-data-table__mobile-table-row': isMobile }"
          >
            <td
              :colspan="`${isMobile ? 6 : 2}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              <strong>{{ $t("sum-total") }}</strong> :
            </td>
            <td
              :colspan="`${isMobile ? 6 : +headerPrint.length - 3}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            ></td>
            <td
              :colspan="`${isMobile ? 6 : 2}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("sum") + ":" : "" }}
              {{ $numberFormat(productItemsInvoice.sum_amount) }}
              {{ $store.state.currency.name }}
              <span v-if="productItemsInvoice.Commission != null">
                | {{ $t("allocationAmount") }}:
                {{ $numberFormat(productItemsInvoice.Commission) }}
                {{ $store.state.currency.name }}
              </span>
            </td>
          </tr>
          <tr
            v-if="reviewTotalsProp"
            :class="{ 'v-data-table__mobile-table-row': isMobile }"
          >
            <td
              :colspan="`${isMobile ? 6 : 3}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              <strong>{{ $t("sum") }}</strong>
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("debtor") + ":" : "" }}
              {{ $numberFormat(reviewTotalsProp.debtor) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("creditor") + ":" : "" }}
              {{ $numberFormat(reviewTotalsProp.creditor) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("debtorRemain") + ":" : "" }}
              {{ $numberFormat(reviewTotalsProp.debtorRemain) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("creditorRemain") + ":" : "" }}
              {{ $numberFormat(reviewTotalsProp.creditorRemain) }}
            </td>
          </tr>
          <tr
            v-if="reviewTotalsProp"
            :class="{ 'v-data-table__mobile-table-row': isMobile }"
          >
            <td
              :colspan="`${isMobile ? 6 : 5}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              <strong>{{ $t("remain") }}</strong>
            </td>
            <td
              :colspan="`${isMobile ? 6 : 2}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
              :style="{ 'padding-right': !isMobile ? '70px' : '0' }"
            >
              {{ isMobile ? $t("remain") + ":" : "" }}
              {{
                $numberFormat(
                  +reviewTotalsProp.creditorRemain - +reviewTotalsProp.debtorRemain
                )
              }}
            </td>
          </tr>
          <tr
            v-if="invoiceTotalsProp"
            :class="{ 'v-data-table__mobile-table-row': isMobile }"
          >
            <td
              :colspan="`${
                isMobile
                  ? 6
                  : Number(headerProp.length) - 15 + (typeProp !== 'sell' ? 1 : 0)
              }`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              <strong>{{ $t("sum") }}</strong>
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("sumNetAmount") + ":" : "" }}
              {{ $numberFormat(invoiceTotalsProp.price) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("discount") + ":" : "" }}
              {{ $numberFormat(invoiceTotalsProp.discount) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("tax") + ":" : "" }}
              {{ $numberFormat(invoiceTotalsProp.tax) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("price") + ":" : "" }}
              {{ $numberFormat(invoiceTotalsProp.sumNetAmount) }}
            </td>
            <td
              v-if="!isMobile"
              :colspan="`${isMobile ? 6 : 5}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            />
          </tr>
          <tr v-if="turnoverProp" :class="{ 'v-data-table__mobile-table-row': isMobile }">
            <td
              :colspan="`${isMobile ? 6 : 7}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              <strong>{{ $t("sum") }}</strong>
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("debtor") + ":" : "" }}
              {{ $numberFormat(turnoverProp.debtor) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("creditor") + ":" : "" }}
              {{ $numberFormat(turnoverProp.creditor) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{
                $numberFormat(
                  parseFloat(turnoverProp.debtor) - parseFloat(turnoverProp.creditor)
                )
              }}
            </td>
            <td
              v-if="!isMobile"
              :colspan="`${isMobile ? 6 : 4}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            />
          </tr>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="customSizeDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="60%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="customSizeDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print-size") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="width"
              outlined
              dense
              type="number"
              :label="$t('width') + '(cm)'"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="height"
              outlined
              dense
              type="number"
              :label="$t('height') + '(cm)'"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn color="primary" @click="setCustomeSize">
                {{ $t("submit") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="customSizeDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import store from "../../../../../store";
import General from "../../../../../Mixins/general";
export default {
  mixins: [General],
  props: [
    "headerProp",
    "itemsProp",
    "title",
    "fromDate",
    "toDate",
    "productItemsInvoice",
    "dataProp",
    "reviewTotalsProp",
    "showSummaryTransferContentProp",
    "invoiceTotalsProp",
    "reviewLevelProp",
    "typeProp",
    "turnoverProp",
  ],
  data() {
    return {
      headerPrint: [],
      items: [],
      width: null,
      height: null,
      customSizeDialog: null,
      printSize: "29.7cm 21cm",
    };
  },
  watch: {
    headerProp() {
      this.headerPrint = this.headerProp;
    },
    itemsProp() {
      this.items = this.itemsProp;
    },
    fromDate() {
      var header = this.$refs.table.$el.querySelector(".v-data-table-header");
      header.deleteRow(0);
      this.makeHeader();
    },
    toDate() {
      var header = this.$refs.table.$el.querySelector(".v-data-table-header");
      header.deleteRow(0);
      this.makeHeader();
    },
    title() {
      var header = this.$refs.table.$el.querySelector(".v-data-table-header");
      header.deleteRow(0);
      this.$refs.table.$el.querySelector("table tbody");
      this.makeHeader();
    },
  },
  beforeMount() {
    var storage = JSON.parse(localStorage.getItem("token"));
    if (storage != null) {
      store.commit("SET_START_DATE", storage.init.startDate);
      store.commit("SET_END_DATE", storage.init.endDate);
      store.commit("SET_DATE_LOCALE", storage.init.date_locale.value);
      if (storage.init.date_locale.value === "fa,en") {
        store.commit("SET_DATE_FORMAT", "jYYYY/jMM/jDD");
      } else {
        store.commit("SET_DATE_FORMAT", "YYYY/MM/DD");
        store.commit("SET_START_DATE", null);
        store.commit("SET_END_DATE", null);
      }
      store.commit("SET_RTL", storage.init.rtl.value);
      store.commit("SET_DARK", storage.init.dark.value);
      store.commit("SET_LANG", storage.init.lang.value);
      store.commit("SET_THEME_COLOR", storage.init.theme_color.value);
    }
    this.$vuetify.theme.dark = this.$store.state.dark;
    this.$root.$i18n.locale = this.$store.state.lang;
    this.$vuetify.theme.themes[
      this.$vuetify.theme.isDark ? "dark" : "light"
    ].primary = this.$store.state.theme_color;
    if (this.$store.state.rtl) {
      this.$vuetify.rtl = true;
      storage.init.rtl.value = true;
      localStorage.setItem("token", JSON.stringify(storage));
    } else {
      this.$vuetify.rtl = false;
    }
  },
  mounted() {
    this.headerPrint = this.headerProp;
    // this.headerPrint.splice(0, 1)
    this.items = this.itemsProp;
    this.makeHeader();
  },
  methods: {
    makeHeader() {
      var printData = {
        title: this.title,
        user: this.$store.state.fullname,
        fromDate: this.fromDate,
        toDate: this.toDate,
      };
      this.setheaderPrint(printData);
    },
    clearCustom() {
      this.height = null;
      this.width = null;
    },
    setCustomeSize() {
      this.printSize = this.width + "cm " + this.height + "cm";
      this.customSizeDialog = false;
    },
    print() {
      var direction = "ltr";
      if (this.$vuetify.rtl) {
        direction = "rtl";
      }
      var style =
        "<style>" +
        "@page { size: " +
        this.printSize +
        " landscape}" +
        // '@media print {html, body {zoom: 75%}}' +
        "@bottom-left {content: normal;margin: 0;}}" +
        "</style>";
      // const prtHtml = document.getElementById('print_dialog').innerHTML
      const prtHtml = this.$el.querySelector("#print_dialog").innerHTML;
      setTimeout(function () {
        // Get HTML to print from element
        let stylesHtml = "";
        let node = null;
        for (node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
          stylesHtml += node.outerHTML;
        }
        const WinPrint = window.open(
          "",
          "",
          "left=0,top=0,width=1100,height=900,toolbar=0,scrollbars=0,status=0"
        );
        WinPrint.document.write(
          "<!DOCTYPE html> <html> <head> " +
            stylesHtml +
            " " +
            style +
            ' </head> <body style="direction: ' +
            direction +
            '">' +
            prtHtml +
            " </body> </html>"
        );
        WinPrint.document.close();
        WinPrint.focus();
        setTimeout(function () {
          WinPrint.print();
          WinPrint.close();
        }, 2000);
      }, 50);
    },
  },
};
</script>

<style scoped>
@media print {
  html,
  body {
    width: 143mm;
    height: 70mm;
  }
}
</style>
